module.exports = __webpack_public_path__ + "assets/img/35_1119_big.b2f55391.jpg";